import { render } from "./altMotionTemplate.vue?vue&type=template&id=f67ec1d6"
import script from "./altMotionTemplate.vue?vue&type=script&lang=js"
export * from "./altMotionTemplate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__